angular.module("UI8.components").component("oldSearchModal", {
  template: `<div class="search">
      <div class="search__head">
        <div class="search__container container">
          <div class="search__field">
            <input class="search__input" ng-model="$root.searchTerm" ng-change="$ctrl.onSearchInput()" ng-keydown="$ctrl.watchKeys($event)" id="search-input" type="search" placeholder="What are you looking for today?" name="search" autocomplete="off" maxlength="20" ui8-no-special-chars />
            <div class="search__value">
              <span>{{ $root.searchTerm }}</span>
              <button ng-if="$root.searchTerm" ng-click="$ctrl.clearSearch()">
                <svg viewBox="0 0 14 14"><path d="M1.988.585l.094.083L7 5.585 11.918.668a1 1 0 0 1 1.497 1.32l-.083.094L8.414 7l4.918 4.918a1 1 0 0 1-1.32 1.497l-.094-.083L7 8.414l-4.918 4.918a1 1 0 0 1-1.497-1.32l.083-.094L5.585 7 .668 2.082A1 1 0 0 1 1.886.515l.101.069z"/></svg>
              </button>
            </div>
          </div>
          <button class="search__close" ng-click="$ctrl.closeSearch()">
            <svg viewBox="0 0 14 14"><path d="M1.988.585l.094.083L7 5.585 11.918.668a1 1 0 0 1 1.497 1.32l-.083.094L8.414 7l4.918 4.918a1 1 0 0 1-1.32 1.497l-.094-.083L7 8.414l-4.918 4.918a1 1 0 0 1-1.497-1.32l.083-.094L5.585 7 .668 2.082A1 1 0 0 1 1.886.515l.101.069z"/></svg>
          </button>
          <button class="search__sale toggle" ng-if="$ctrl.currentSale" ng-class="{ active: $ctrl.seasonalSale }" ng-click="$ctrl.toggleSale()">On Sale</button>
          <div class="search__filters filters">
            <div class="filters__container">
              <div class="filters__categories">
                <div class="filters__tags filters__tags--search" on-load='$ctrl.changeHandler()'>
                  <div class="filters__scroll">
                    <div class="filters__inner">
                      <button class="filters__btn" ng-repeat="category in $ctrl.categoryList track by category.slug" ng-click="$ctrl.updateCategoryFilter(category.slug)" ng-class="$ctrl.isCategoryActive(category.slug)">
                        {{ ::category.name }}
                      </button>
                    </div>
                  </div>
                  <button class="filters__nav filters__nav--prev"></button>
                  <button class="filters__nav filters__nav--next"></button>
                </div>
              </div>
              <div class="filters__select">
                <div class="filters__head">
                  <div class="filters__label">Format</div>
                  <div class="filters__arrow">
                    <img ng-src="/img/app-icons/{{$ctrl.isAppActiveSlug()}}.svg" alt="Select" />
                  </div>
                </div>
                <div class="filters__dropdown isWidest">
                  <button class="filters__btn" ng-repeat="app in $ctrl.appList track by app.slug" ng-click="$ctrl.updateSoftwareFilter(app.name)" ng-class="$ctrl.isAppActive(app.name)">
                    <img ng-src="/img/app-icons/{{::app.slug}}.svg" alt="{{ ::app.name }}" />
                    <span>{{ app.new_name || app.name }}</span>
                  </button>
                </div>
              </div>
              <div class="filters__select">
                <div class="filters__head">
                  <div class="filters__arrow">
                    <svg><path d="M7.414 10c-.891 0-1.337-1.077-.707-1.707l4.586-4.586a1 1 0 0 1 1.414 0l4.586 4.586c.63.63.184 1.707-.707 1.707H7.414zm8.882 5c.928 0 1.356 1.155.651 1.759l-4.297 3.683a1 1 0 0 1-1.302 0l-4.297-3.683C6.347 16.155 6.775 15 7.703 15h8.593z"></path></svg>
                  </div>
                </div>
                <div class="filters__dropdown">
                  <button class="filters__btn" ng-class="{ active: $ctrl.isSortActive('recent') }" ng-click="$ctrl.updateSortFilter('recent')">Release date</button>
                  <button class="filters__btn" ng-class="{ active: $ctrl.isSortActive('popular') }" ng-click="$ctrl.updateSortFilter('popular')">Popularity</button>
                  <button class="filters__btn" ng-if="!$ctrl.isCategoryFreebies()" ng-class="{ active: $ctrl.isSortActive('high') }" ng-click="$ctrl.updateSortFilter('high')">Highest price</button>
                  <button class="filters__btn" ng-if="!$ctrl.isCategoryFreebies()" ng-class="{ active: $ctrl.isSortActive('low') }" ng-click="$ctrl.updateSortFilter('low')">Lowest price</button>
                  <div class="featured-filter">
                    <button class="filters__toggle" ng-class="{ active: $ctrl.featured }" ng-click="$ctrl.toggleFeatured()">Featured</button>
                  </div>
                  <div class="has-dna-filter">
                    <button class="filters__toggle" ng-class="{ active: $ctrl.hasDesignDna }" ng-click="$ctrl.toggleHasDesignDna()">AI-Ready</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="search__body">
        <div class="search__container container">
          <div class="search__empty" ng-if="$ctrl.empty">
            <div class="search__alert">
              <div class="search__title">No results...</div>
              <div class="search__text">We couldn’t find any results based on your search terms. Adjust your parameters and try again.</div>
            </div>
            <ul class="search__placeholders"><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li><li></li></ul>
          </div>
          <div class="search__catalog catalog" ng-if="!$ctrl.empty">
            <product-card ng-repeat="product in $ctrl.products track by product._id + '_' + $index" product='product' user='$ctrl.user'></product-card>
          </div>
          <div class="loader" ng-class="{ loading: $ctrl.searching, faded: !$ctrl.loadingMore && !$ctrl.searching }" ui8-lazy-load when-visible="$ctrl.loadMore()" disable="$ctrl.disabled" container="$ctrl.container">
        </div>
      </div>
    </div>`,

  controller: function ($rootScope, $location, ProductService, HistoryService) {
    var ctrl = this;
    var keywords = /(sketch|ui kit|wireframe kit|theme|icon|font|illustration|freebie)(s)?\:(\s)?/gi;
    var $searchInput;

    ctrl.appList = [
      {
        name: "Any Platform",
        slug: "any-prog",
        alt_name: "Any Software",
        new_name: "Any format",
      },
      {
        name: "After Effects",
        slug: "ae-prog",
      },
      {
        name: "Android",
        slug: "android-prog",
      },
      {
        name: "Blender",
        slug: "blender-prog",
      },
      {
        name: "Bootstrap",
        slug: "bootstrap-prog",
        new_name: "Bootstrap",
      },
      {
        name: "Cinema 4D",
        slug: "c4d-prog",
      },
      {
        name: "Figma",
        slug: "figma-prog",
      },
      {
        name: "Framer",
        slug: "framer-prog",
      },
      {
        name: "HTML",
        slug: "html-prog",
        new_name: "HTML/CSS",
      },
      {
        name: "Illustrator",
        slug: "ai-prog",
      },
      {
        name: "Keynote",
        slug: "keynote-prog",
      },
      {
        name: "Photoshop",
        slug: "ps-prog",
      },
      {
        name: "PowerPoint",
        slug: "powerpoint-prog",
      },
      {
        name: "Procreate",
        slug: "procreate-prog",
      },
      {
        name: "React",
        slug: "react-prog",
      },
      {
        name: "Sketch",
        slug: "sketch-prog",
      },
      {
        name: "Spline",
        slug: "spline-prog",
      },
      {
        name: "Swift",
        slug: "swift-prog",
      },
      {
        name: "Xcode",
        slug: "xcode-prog",
      },
      {
        name: "Webflow",
        slug: "webflow-prog",
      },
    ];

    ctrl.categoryList = [
      {
        name: "All Products",
        slug: "all",
      },
      {
        name: "UI Kits",
        slug: "ui-kits",
      },
      {
        name: "Coded Templates",
        slug: "coded-templates",
      },
      {
        name: "No Code",
        slug: "no-code",
      },
      {
        name: "Illustrations",
        slug: "illustrations",
      },
      {
        name: "Fonts",
        slug: "fonts",
      },
      {
        name: "Wireframe Kits",
        slug: "wireframe-kits",
      },
      {
        name: "Presentation",
        slug: "presentation",
      },
      {
        name: "Mockups",
        slug: "mockups",
      },
      {
        name: "3D Assets",
        slug: "3d-assets",
      },
      {
        name: "Icons",
        slug: "icons",
      },
      {
        name: "Themes",
        slug: "themes",
      },
      {
        name: "Freebies",
        slug: "freebies",
      },
    ];

    ctrl.products = [];
    ctrl.disabled = false;
    ctrl.searching = false;
    ctrl.loadingMore = false;
    ctrl.requestNumber = 1;
    ctrl.empty = false;
    ctrl.currentSale = window.UI8.currentSale || false;
    ctrl.seasonalSale = false;
    ctrl.featured = false;
    ctrl.hasDesignDna = false;
    ctrl.searchInputValue = "";

    ctrl.$onInit = function () {
      $searchInput = $("#search-input");

      if ($(window).width() < 768) {
        $searchInput.attr("placeholder", "Type to search...");
      }

      ctrl.user = $rootScope.user;
      updateCategoryFilter($rootScope.categoryFilter || "all");
      updateAppFilter($rootScope.appFilter);
      updateSortFilter($rootScope.sortFilter || "recent");

      $searchInput.focus();

      if ($rootScope.searchTerm == null) {
        $rootScope.searchTerm = restoreSearchTerm();
      }

      ctrl.page = getPageNumber();

      ctrl.container = $(".search");

      runSearch(0);

      function isGoingToProduct(oldPath, oldUrl) {
        return oldUrl.includes("?search=1");
      }

      HistoryService.rememberScrollPosition(
        isGoingToProduct,
        "search",
        function () {
          var el = document.querySelector(".search");
          return el ? el.scrollTop : 0;
        }
      );

      // Added delay to ensure DOM is ready
      setTimeout(function () {
        // Tags scroll navigation
        var tags = $(".filters__tags--search"),
          scroll = tags.find(".filters__scroll"),
          inner = scroll.find(".filters__inner"),
          nav = tags.find(".filters__nav");

        // Check if tags are scrollable
        if (inner.width() > scroll.width()) {
          tags.addClass("is-next");
        }

        // Tags scroll navigation
        nav.on("click", function () {
          var _this = $(this),
            scrollOffset = scroll.width() / 2;

          if (_this.hasClass("filters__nav--prev")) {
            scroll.scrollLeft(scroll.scrollLeft() - scrollOffset);
          } else {
            scroll.scrollLeft(scroll.scrollLeft() + scrollOffset);
          }
        });

        function updateScroll() {
          const el = scroll[0];
          const scrollLeft = el.scrollLeft;
          const maxScrollLeft = el.scrollWidth - el.clientWidth;

          // At start?
          if (scrollLeft > 0) {
            tags.addClass("is-prev");
          } else {
            tags.removeClass("is-prev");
          }

          // At end?
          if (scrollLeft < maxScrollLeft - 1) {
            tags.addClass("is-next");
          } else {
            tags.removeClass("is-next");
          }
        }

        // Add scroll event listener
        scroll.on("scroll", updateScroll);

        // Add resize event listener
        $(window).on("resize", updateScroll);

        updateScroll();
      }, 10);
    };

    ctrl.isAppActive = function (appName) {
      return appName === $rootScope.appFilter ? "active" : "";
    };

    ctrl.isAppActiveSlug = function () {
      return ctrl.appList.find((filter) => filter.name === $rootScope.appFilter)
        .slug;
    };

    ctrl.isCategoryActive = function (categorySlug) {
      return categorySlug === $rootScope.categoryFilter ? "active" : "";
    };

    ctrl.isCategoryFreebies = function () {
      return $rootScope.categoryFilter === "freebies";
    };

    ctrl.isSortActive = function (sort) {
      return sort === $rootScope.sortFilter ? "active" : "";
    };

    ctrl.updateSoftwareFilter = function (appName) {
      updateAppFilter(appName);
      runSearch(0);
    };

    ctrl.updateCategoryFilter = function (categorySlug) {
      updateCategoryFilter(categorySlug);
      runSearch(0);
    };

    ctrl.updateSortFilter = function (sort) {
      updateSortFilter(sort);
      runSearch(0);
    };

    const debouncedRunSearch = debounce(() => runSearch(0), 500);
    ctrl.onSearchInput = function () {
      debouncedRunSearch();
    };

    ctrl.clearSearch = function () {
      $rootScope.searchTerm = "";
      updateSearchTerm("");
      runSearch(0);
    };

    ctrl.loadMore = function () {
      ctrl.loadingMore = true;
      runSearch(ctrl.page + 1);
    };

    ctrl.closeSearch = function () {
      $rootScope.showSearch = false;
      $location.search("search", null);
      $("body").css("overflow-y", "scroll");
    };

    // $rootScope.$watch("cart", function (cart) {
    //   if (cart) ctrl.closeSearch();
    // });

    ctrl.watchKeys = function (e) {
      if (e.keyCode === 27) return ctrl.closeSearch();
    };

    ctrl.toggleSale = function () {
      ctrl.seasonalSale = !ctrl.seasonalSale;
      runSearch(0);
    };

    ctrl.toggleFeatured = function () {
      ctrl.featured = !ctrl.featured;
      runSearch(0);
    };

    ctrl.toggleHasDesignDna = function () {
      ctrl.hasDesignDna = !ctrl.hasDesignDna;
      runSearch(0);
    };

    function debounce(func, delay) {
      let timer;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
      };
    }

    function updateDisabled(resultsCount) {
      ctrl.disabled = resultsCount <= ctrl.products.length;
    }

    function runSearch(page) {
      const currentReq = ++ctrl.requestNumber;

      ctrl.page = page;
      var category = keywords.exec($rootScope.searchTerm);
      updateSearchTerm($rootScope.searchTerm);

      if (category) {
        updateCategoryFilter(category[0].replace(/\s+/g, "-").toLowerCase());
      }

      ctrl.searching = true;
      ctrl.disabled = true;

      if (page === 0) {
        ctrl.products = [];
      }
      setPageNumber(page);

      var query = {
        search: $rootScope.searchTerm,
        page: ctrl.page,
      };

      if (ctrl.seasonalSale) {
        query.seasonal_sale = true;
      }

      if (ctrl.featured) {
        query.featured = true;
      }

      if (ctrl.hasDesignDna) {
        query.hasDesignDna = true;
      }

      if ($rootScope.appFilter && $rootScope.appFilter !== "Any Platform") {
        query.compatibility = $rootScope.appFilter;
      }

      if ($rootScope.categoryFilter && $rootScope.categoryFilter !== "all") {
        query.category = $rootScope.categoryFilter;
      }

      if ($rootScope.sortFilter) {
        query.sort = $rootScope.sortFilter;
      }

      return ProductService.search(query)
        .then(function (response) {
          if (ctrl.requestNumber !== currentReq) {
            return; // Another request was started, we don't need this data
          }
          ctrl.products = ctrl.products.concat(response.products);
          updateDisabled(response.totalCount);

          ctrl.empty = !response.totalCount;

          if (response.pages !== 0 && page === 0) {
            setTimeout(function () {
              document.querySelector(".search").scrollTop = getTop();
            }, 0);
          }
        })
        .catch(function () {
          console.error("Error during search");
          updateDisabled(0);
        })
        .finally(function () {
          ctrl.searching = false;
          ctrl.loadingMore = false;
        });
    }

    function updateCategoryFilter(val) {
      val = val || sessionStorage.getItem("search:category-filter");

      $rootScope.categoryFilter = val || "any";
      sessionStorage.setItem(
        "search:category-filter",
        $rootScope.categoryFilter
      );

      if ($rootScope.categoryFilter === "freebies") {
        $rootScope.sortFilter = "recent";
      }
    }

    function updateAppFilter(val) {
      val = val || sessionStorage.getItem("search:app-filter");

      $rootScope.appFilter = val || "Any Platform";
      sessionStorage.setItem("search:app-filter", $rootScope.appFilter);
    }

    function updateSortFilter(val) {
      val = val || sessionStorage.getItem("search:sort-filter");
      $rootScope.sortFilter = val || "recent";
      sessionStorage.setItem("search:sort-filter", $rootScope.sortFilter);
    }

    function restoreSearchTerm() {
      return sessionStorage.getItem("search:term") || "";
    }

    function updateSearchTerm(val) {
      sessionStorage.setItem("search:term", val);
    }

    function setPageNumber(page) {
      sessionStorage.setItem("search:page", page);
    }

    function getPageNumber() {
      var page = sessionStorage.getItem("search:page") || 0;
      sessionStorage.removeItem("search:page");
      return +page;
    }

    function getTop() {
      var top = sessionStorage.getItem("top:search") || 0;
      sessionStorage.removeItem("top:search");
      return parseInt(top, 10);
    }

    // function updateSearchInput(term) {
    //   if (term && $searchInput && $searchInput.val() !== term) {
    //     $searchInput.val(term);
    //   }
    // }
  },
});
